import NoResults from 'fe-design-base/assets/illustrations/NoResults';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { cxHelpers } from 'util/className';

const { cx } = cxHelpers('ComponentName');

type EmptyListItemProps = {
  type: 'requests' | 'alerts';
};

const EmptyListItem = ({ type }: EmptyListItemProps) => (
  <Box className={cx()}>
    <Box mt={48} p={12} tcenter flex column gap={12}>
      <Box alignSelfCenter>
        <NoResults h={48} w={48} />
      </Box>
      <Box tcenter pt={16}>
        <Text
          color="mono700"
          variant="heading3"
          i18n={`notifications.${type}.empty_title`}
        />
      </Box>
      <Box tcenter>
        <Text color="mono700" i18n={`notifications.${type}.empty_desc`} />
      </Box>
    </Box>
  </Box>
);

export default EmptyListItem;
